<template>
  <v-container v-if="!isLoggedIn">
    <v-layout row>
      <v-flex xs12 sm6 md6>
        <v-img :src="require('@/assets/Login.jpg')" height="auto"></v-img>
      </v-flex>
      <v-flex xs12 sm6 md6 class="ml-5">
        <v-layout row wrap justify-center>
          <h5 class="display-2 font-weight-bold mb-3">Login</h5>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-alert :value="getAuthSigninResponse" type="warning">
            {{ getAuthSigninResponse }}
          </v-alert>
        </v-layout>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="allLogData.email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>

          <v-text-field
            v-model="allLogData.password"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :rules="passwordRules"
            label="Password"
            required
          ></v-text-field>

          <v-btn class="mr-2 ml-0"
            :disabled="!valid"
            v-if="allLogData.email && allLogData.password"
            color="success"
            @click="login(allLogData)"
          >
            Submit
          </v-btn>

          <v-btn color="error" class="mx-0" @click="reset">Clear</v-btn>

          <router-link
            to="/forgot-password"
            tag="span"
            style="cursor: pointer; color: #42a5f5"
          >
            <p class="mt-3 custom-font-size">Have you forgotten your password?</p>
          </router-link>

          <p class="mt-3 mb-1 custom-font-size">
            New to DataDash?
            <router-link
              to="/signup"
              tag="span"
              style="cursor: pointer; color: #42a5f5"
            >
              Sign Up
            </router-link>
          </p>

          <!-- <v-btn color="warning" @click="resetValidation">Reset password</v-btn> -->
        </v-form>
      </v-flex>
      <v-flex xs1 sm1 md2 lg3></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    show1: false,
    valid: true,
    allLogData: {
      email: "",
      password: "",
    },
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    passwordRules: [
      (v) => !!v || "password is required",
      (v) => (v && v.length > 5) || "minimum 6 characters",
    ],
  }),

  computed: {
    ...mapGetters(["isLoggedIn", "getAuthSigninResponse", "error", "errorMsg"]),
  },

  methods: {
    ...mapActions(["login"]),
    validate() {
      if (this.allFormData.password) {
        return (this.show1 = true);
      } else {
        this.show1 = false;
      }

      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
<style scoped>
.custom-font-size {
  font-size: 13px;
}
</style>
